export enum ErrorEnum {
  NO_ACCESS = "auth/no-access",
  WRONG_PASSWORD = "auth/wrong-password",
}
